<template>
  <div>
    <v-container pa-0 fluid>
      <v-container>
        <v-layout row justify-center wrap text-xs-center>
          <v-flex xs12 my-3>
            <svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.666645 7C0.666645 3.54822 3.65037 0.75 7.33098 0.75L20.669 0.75C24.3496 0.75 27.3333 3.54822 27.3333 7C27.3333 10.4518 24.3496 13.25 20.669 13.25L7.33098 13.25C3.65037 13.25 0.666645 10.4518 0.666645 7Z" fill="#E91E63"/>
            </svg>
          </v-flex>
          <v-flex xs12 class="navy--text desktop-h1">
            Manipulatives
          </v-flex>
        </v-layout>
      </v-container>
      <v-container pt-3 pb-3 title text-xs-center v-if="expiringNotice">
        <v-layout justify-center pb-0 wrap>
          <v-flex xs12 sm6>
            <v-alert
              :value="true"
              color="accent"
              outline
            >
              You have {{ daysRemaining }} days remaining on your license.
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container py-3 pb-0 title text-xs-center v-if="allExpiredNotice">
        <v-layout justify-center pb-0 wrap>
          <v-flex xs12 sm6>
            <v-alert
              :value="true"
              color="error"
              outline
            >
              Your license has expired. Easily renew your license now by clicking <a style="color: #3296f3; text-decoration: underline" href="https://www.brainingcamp.com/pricing" target="_blank">here.</a>
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container grid-list-md fluid v-if="loading">
        <v-layout justify-center>
          <v-flex xs12 font-weight-bold ma-5 text-xs-center>
            <v-progress-circular color="secondary" indeterminate :size="50"></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container style="max-width: 720px" pb-1 v-if="presentOffer">
        <v-layout justify-center headline font-weight-medium wrap elevation-1 py-3 ma-3>
          <v-flex xs12 sm9 pl-3 mt-2>
            <p class="subheading">Your redeemed manipulatives are activated. Try the others?</p>
            
          </v-flex>
          <v-flex xs12 sm3 text-xs-center text-sm-right>
            <v-btn
              color="accent"
              @click="redeemOffer"
              v-if="!processingRequest"
            >
              3 Months Free
            </v-btn>
            <v-progress-circular
              v-if="processingRequest"
              indeterminate
              color="secondary"
            ></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container text-xs-center>
        <v-layout row wrap justify-middle align-start>
          <v-flex xs6 sm3 md2 my-1 v-for="scope in scopes" :key="scope.id">
            <ManipulativeItem :id="scope.id" :enabled="scope.enabled"/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
    <v-container fluid text-xs-center pa-0 v-if="false && !isClassroom" style="background: linear-gradient(to bottom, white 50%, #EBF5FE 50%);">
        <a href="https://bit.ly/3OAMsuU" target="_blank">
          <img src="@/assets/upcoming-webinar.png" style="width: 100%; max-width: 800px; display: block; margin: auto">
        </a>
    </v-container>
    <v-container pa-0 ice lighten-1 fluid>
      <div class="decoration_container">
          <div class="decoration hidden-sm-and-down" style="right: 0; top: -80px; z-index: 1">
            <svg width="165" height="360" viewBox="0 0 165 360" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_15299_31450)">
                <mask id="mask0_15299_31450" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="341" height="341">
                  <circle cx="170.102" cy="170.102" r="170.102" transform="rotate(90 170.102 170.102)" fill="#FBC109"/>
                </mask>
                <g mask="url(#mask0_15299_31450)">
                  <rect x="164.633" y="-34.6797" width="374.883" height="164.633" transform="rotate(90 164.633 -34.6797)" fill="#FBC109"/>
                </g>
              </g>
              <defs>
                <clipPath id="clip0_15299_31450">
                  <rect width="360" height="165" fill="white" transform="translate(165) rotate(90)"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      <v-container pa-0 style="position: relative; z-index: 2;">
        <v-layout row justify-center wrap>
          <v-flex xs12 md6 pa-5 text-xs-center text-md-left>
            <p class="navy--text" style="font-size: 36px; font-weight: 600">
              Want to use an iPad?
            </p>
            <div class="mt-3">
              <a href="https://itunes.apple.com/us/app/virtual-manipulatives/id1173021675?mt=8" target="_blank">
                <v-btn
                  color="gold"
                  depressed
                  large
                >
                  Download Now
                </v-btn>
              </a>
            </div>
          </v-flex>
          <v-flex xs12 md6 pa-5 text-xs-center>
            <a href="https://itunes.apple.com/us/app/virtual-manipulatives/id1173021675?mt=8" target="_blank">
              <img src="@/assets/ipad.png" style="width: 100%; max-width: 600px;">
            </a>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
    <v-dialog v-model="showFeaturePreview" width="1280">
      <v-layout wrap white>
        <v-flex xs12 v-if="showFeaturePreview">
          <video controls style="width:100%; display:block" src="https://media.brainingcamp.com/v/848323422.mp4"></video>
        </v-flex>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
import manips from '@/data/manips.js'
import _ from 'lodash'
import LicensingService from '@/services/LicensingService'
import ManipulativeItem from '@/components/ManipulativeListItem'

export default {
  data: function () {
    return {
      showWebinar: true,
      loading: null,
      processingRequest: null,
      licenses: [],
      hasBundle: false,
      scopes: [],
      expiringNotice: false,
      daysRemaining: null,
      allExpiredNotice: false,
      presentOffer: false,
      showFeaturePreview: false,
      showShareDialog: false
    }
  },
  components: {
    ManipulativeItem
  },
  mounted: async function () {
    this.loading = true
    try {
      const result = await LicensingService.get()

      const unsortedLicenseList = result.data

      // sort by createdBy date before setting to vue
      this.licenses = _.reverse(_.sortBy(unsortedLicenseList, 'createdAt'))
    } catch (err) {
      if (err.response.status === 403) {
        this.$router.push({
          path: '/logout'
        }).catch(err => {})
      }
    }
    this.loading = false
  },
  computed: {
    isClassroom: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.type === 'classroom';
      }
      return false;
    }
  },
  methods: {
    redeemOffer: async function() {
      this.processingRequest = true
      try {
        const result = await LicensingService.requestKitUpgrade()

        if (result) {
          this.refreshLicenses()
        }
      } catch (err) {
        // console.log(err.response.data.error)
      }
      this.processingRequest = false
    },
    refreshLicenses: async function() {
      try {
        const result = await LicensingService.get()

        const unsortedLicenseList = result.data

        // sort by createdBy date before setting to vue
        this.licenses = _.reverse(_.sortBy(unsortedLicenseList, 'createdAt'))
      } catch (err) {
        if (err.response.status === 403) {
          this.$router.push({
            path: '/logout'
          })
        }
      }
    }
  },
  watch: {
    licenses: function() {
      var greatestExpirationDate = null
      var hasValidBundleScope = false
      let hasLessonAccess = false
      let hasUpgrade = false
      let bundleScopeFound = false
      let hasCovidGrant = false
      var vendor = undefined
      var scopes = []
      var now = new Date()
      var noticeDate = new Date(); 
      noticeDate.setDate(noticeDate.getDate() + 45);
      
      this.licenses.forEach(license => {
        var expDate = new Date(license.expiration.slice(0, 10))

        
        if (greatestExpirationDate === null || expDate > greatestExpirationDate) {
          greatestExpirationDate = expDate
        }
        if (license.scope === "*") {
          bundleScopeFound = true
        }
        
        if (expDate > now) {
          if (license.scope === "*") {
            hasValidBundleScope = true
          } else {
            scopes.push(license.scope)
          }

          if (license.grantsLessonAccess) {
            hasLessonAccess = true
          }

          if (license.source === 'KIT_TRIAL') {
            hasUpgrade = true
          }

          if (license.source === 'CLOSURES2020SCHOOL' || license.source === 'CLOSURES2020PARENT' || license.source === 'CLOSURES2020CLASS') {
            hasCovidGrant = true
          }
        }

        if (vendor === undefined) {
          vendor = license.vendor
        }
      })

      vendor = vendor === undefined ? null : vendor

      // set the state for vendor
      this.$store.dispatch('setVendor', vendor)
      
      // present expiring notice
      if (greatestExpirationDate < noticeDate) {
        this.expiringNotice = true
        this.daysRemaining = Math.ceil(Math.abs((greatestExpirationDate.getTime() - now.getTime()) / (24 * 60 * 60 * 1000)))

        if (scopes.length === 0 && !hasValidBundleScope) {
          this.allExpiredNotice = true
          this.expiringNotice = false
        }
      } else {
        this.expiringNotice = false
        this.allExpiredNotice = false
      }

      if (hasCovidGrant) {
        this.expiringNotice = false
      }
      
      // determine if the hand2mind offer should display
      if (this.$store.getters.vendor === 'hand2mind' && !hasUpgrade && !bundleScopeFound && scopes.length >= 0) {
        this.presentOffer = true
      } else {
        this.presentOffer = false
      }

      if (this.$store.getters.user.type === 'classroom') {
        this.presentOffer = false
        this.allExpiredNotice = false
        this.expiringNotice = false
        this.daysRemaining = 100
      }

      // set the state for lesson access
      this.$store.dispatch('setLessonAccess', hasLessonAccess)
      
      // prepare ui
      this.hasBundle = hasValidBundleScope
      
      this.scopes = manips.map(item => {
        
        if (_.includes(scopes, item.id) || this.hasBundle) {
          return {id: item.id, enabled: true}
        }

        return {id: item.id, enabled: false}
      })
    }
  }
}
</script>

<style scoped>
.webinar-card {
  width: 280px;
  background: white;
  border: 2px solid #D7EBFF;
  border-radius: 18px;
  padding: 24px;
}

.max_w {
  max-width: 1200px;
}


.codeInput >>> input {
  text-transform: uppercase;
}
.decoration_container {
  position: relative;
}

.decoration_container .decoration {
  position: absolute;
}
</style>
